export default __webpack_public_path__ + "static/media/WNo.2-1.95dd87f0.jpg";